import React from "react";
import SignIn from "../Component/account/SignIn";
import SignUp from "../Component/account/SignUp";
import { useParams } from "react-router-dom";
import Navbar from "../Component/NavBar/Header";
import Footer from "../Component/FooterComponent/Footer";

export default function Account() {
  const { page } = useParams();
  return (
    <>
      <div className="login-page">
        <div className="container">
          {page === "sign-in" ? <SignIn /> : null}
          {page === "sign-up" ? <SignUp /> : null}
        </div>
      </div>
    </>
  );
}
